import map from "../../app/map";
import store from "../../app/store";
import RadarCalendar from "./RadarCalendar";
import products from "../../app/products";
import utils from "../../app/utils";
import Evented from "../../app/Evented";

import RadarTimeSliderController from "./RadarTimeSliderController"
import RadarTimeSliderView from "./ui/RadarTimeSliderView";


import radarLayer from "./tileRadarLayerInstance";
import radarTileInterpolator from "./RadarTileInterpolator";

// import "maps-base/assets/css/plugins/radar/radar.scss";
import "../../../../maps-frontend/assets/css/plugins/radar/radar.scss";
import radarhtml from "../../../../maps-frontend/modules/templates/plugins/radar/radar.pug";
import RadarAnimation from "./RadarAnimation";
import RadarStaticAnimation from "./RadarStaticAnimation";
import rootScope from "../../app/rootScope";
import RangeView from "../../ui/RangeView";
import RangeListView from "../../ui/RangeListView";
import RadarRangeSwitchController from "./RadarRangeSwitchController";
import RadarTileInterpolator from "./RadarTileInterpolator";



const productRadar=products.radar,
    RadarEvented = Evented.instance({
        ident: "radar"
    });

let radarTimeSliderController = null,
    radarStaticAnimation = new RadarStaticAnimation(),
    radarAnimation = new RadarAnimation(radarLayer),
    rangeTimeSwitchController = null,
    updateTimeRadar,
    tsFiveMinutes = 5 * utils.tsMinute,
    intervalRefreshID = null,
    prevValueIsolines= null;
    // radarLayer = new TileRadarLayer( scope.tileServer +'/img/foreground/gray/{z}/{x}/{y}'+(scope.isRetina ? "@2x" : "")+'.png');



function updateRadarCalendar(minifest) {
    productRadar.minifest = minifest;
    let ts = store.get("radarTimestamp")
        , remainTime = 0;

    if (productRadar.calendar)
        remainTime = productRadar.calendar.end - ts;

    let calendar = productRadar.calendar = RadarCalendar.instance({
                minifestFile: minifest,
                premium: store.get("premium"),
            })
        , start = calendar.start
        , end = calendar.end;

    store.set("radarCalendar", productRadar.calendar);

    if (ts > end || ts < start)
        store.set("radarTimestamp", utils.bound(ts, start, end));


}

let firstTime = true;

function enableRadarLayer(){

        radarLayer.init();
        radarLayer.addTo(map);
        if (radarLayer.failed) {
            console.error("It seems that radar failed. ");
            return void store.set("overlay", "wind");
        }

        if (firstTime) {
            store.on("radarTimestamp",
                function (ts) {
                    radarLayer.timestampChanged(ts);
                }
            );
            firstTime = false;
        }

}

function loadedMinifest(response) {
    const minifest = response.data;
    if(updateTimeRadar !== minifest.generated) {
        updateRadarCalendar(minifest);
        updateTimeRadar = minifest.generated;
        if(store.get("radarAnimation") && ! radarAnimation.playing) {
            radarStaticAnimation.startAnimation(10, false);
        }else{
            const now = new Date();
            store.set("radarTimestamp", now.getTime());
        }
    }
}

function loadMinifestError(e) {
    console.error("radarCalendar", "Unable to create cal from minifest", e)
}

function loadMinifest() {
    productRadar.loadMinifest(true).then(loadedMinifest).catch(loadMinifestError)
}


RadarEvented.on("open", function() {

        if (!radarTimeSliderController) {
            const timeSliderElement = document.querySelector("#controles_radar");
            if (timeSliderElement) {
                const timeSliderView = new RadarTimeSliderView(timeSliderElement);
                radarTimeSliderController = new RadarTimeSliderController(timeSliderView, radarStaticAnimation, radarAnimation);
            }
        }

        if (!rangeTimeSwitchController){
            const rangeTimeSwitchElement = document.querySelector("#comborangoradar");
            if (rangeTimeSwitchElement) {
                const rangeTimeSwitchView = new RangeListView(rangeTimeSwitchElement);
                rangeTimeSwitchController = new RadarRangeSwitchController(rangeTimeSwitchView);
            }
        }else
            rangeTimeSwitchController.addElements();

        const promise = productRadar.loadMinifest().then(loadedMinifest).then(enableRadarLayer); //.catch(loadMinifestError);
        radarLayer.loadingPromise = promise;

        promise.catch(loadMinifestError);
        if (!intervalRefreshID)
            intervalRefreshID = setInterval(loadMinifest, tsFiveMinutes);
    }
)

RadarEvented.on("close", function (){
        map.removeLayer.call(map, radarLayer);
        updateTimeRadar=null;
        if(intervalRefreshID)
            clearInterval(intervalRefreshID);
    }
)



export const plugincode={html: radarhtml({
        domain: rootScope.resourcesServer
    })}; //radarcss;

export default {

    interpolator: RadarTileInterpolator.instance(),

    redraw: function () {

    },
    onopen: function (params) {
        RadarEvented.emit("open");
        prevValueIsolines = store.get("isolines");
        store.set("isolines", "off", { doNotStore: true });
    },
    paramsChanged: function (){

    },
    onclose: function () {
        if(prevValueIsolines)
            store.set("isolines", prevValueIsolines);
        RadarEvented.emit("close");
    }
}


